import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-wrapper-addons',
  standalone: true,
  template: `
    <div data-debug="formly-read-only-wrapper">
      <span class="f-w-600">{{ props.label }}: </span> <span [innerHtml]="value || '--'"></span>
    </div>
  `,
})
export class FormlyReadOnlyWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild('fieldComponent', { read: ViewContainerRef })
  override fieldComponent!: ViewContainerRef;

  override field: FormlyFieldConfig;

  tmpl = '';

  private valueFormatter: (value: any) => any;

  constructor(private santitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {
    if (this.props.valueFormatter) {
      this.valueFormatter = this.props.valueFormatter;
    }
  }

  get value(): string | SafeHtml {
    return this.valueFormatter
      ? this.santitizer.bypassSecurityTrustHtml(this.valueFormatter(this.formControl.value))
      : this.formControl.value;
  }
}
